import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
    show: false,
    showSidebar: true,
    parentXs: 12,
    parentMd: 12,
    parentLg: 9,
    parentXl: 9,
    sidebarXs: 12,
    sidebarMd: 12,
    sidebarLg: 3,
    sidebarXl: 3,
    xs: 12,
    md: 12,
    lg: 12,
    xl: 12,
};

export const actionTypes = {
    ShowPortal: "[SHOW_PORTAL] Action",
    HidePortal: "[HIDE_PORTAL] Action",
};

export const reducer = persistReducer(
    { storage, key: "portal" },
    (state = initialState, action) => {
        
        const { type } = action;

        switch (type) {
        case actionTypes.ShowPortal: 
            return {
                show: true,
                showSidebar: false,
                parentXl: 7,
                parentLg: 7,
                xl: 5,
                lg: 5,
                parentMd: 12,
                md: 12,
                parentXs: 12,
                xs: 12,
                sidebarXs: 12,
                sidebarMd: 12,
                sidebarLg: 12,
                sidebarXl: 12,
            };
        case actionTypes.HidePortal: 
            return initialState;
        default:
            return state;
      }
    }
);

export const actions = {
    showPortal: payload => ({ type: actionTypes.ShowPortal, payload: payload }),
    hidePortal: payload => ({ type: actionTypes.HidePortal, payload: payload })
};
  
  